<template>
	<div class="packages">
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>整装整租</span>
			<span></span>
		</div>
		<div style="height: 2rem;"></div>
		<div style="">
			<!-- 导航区域 -->
			<ul class="navs" style="overflow-y: auto;">
				<li v-for="(item,index) in seelists" @click="scrollTo(index)">
					<div v-if="item.sublist.length != 0" :class="{active: active===index}">
						<van-icon :name="active==index?item.image2:item.image" size="27px" />
						<div style="font-size: 0.8125rem;">{{item.title}}</div>
					</div>
				</li>
			</ul>
			<!-- 内容区域 -->
			<div class="content">
				<div class="div" v-for="(item,index) in seelists">
					<div class="zhuangshi" v-if="item.sublist.length != 0">
						<img src="../../assets/zhuangshiz.png" />
						<div class="title" style="color: #999; font-size: 0.875rem; line-height: 1.25rem;">{{item.title}}</div>
						<img src="../../assets/zhuangshiy.png" />
					</div>

					<div class="block" v-for="(items,index) in item.sublist" style="position: relative;">
						<div class="xinjiu">{{items.newold}}</div>
						<img :src="items.slider_image" @click="gotu(items.id)" />
						<div class="right">
							<div class="text" @click="gotu(items.id)">{{items.title}}</div>
							<div class="price">￥{{items.price}}元/<span style="font-size: 0.75rem;">月起</span></div>
							<div class="shuxing">剩余{{items.goods_stuck}}</div>
							<van-stepper style="position: absolute; bottom: 10px; right: 5px;" min="0" v-model="items.num" @change="onChange(items.id,items.num)" />
						</div>
					</div>
				</div>
				<div style="height: 4rem;"></div>
			</div>
		</div>
		<van-popup v-model="show" closeable position="bottom" :style="{ height: '50%' }">
			<div class="gouwuche">
				<div style="font-weight: bold; text-align: left; font-size: 0.875rem;">已选中商品列表</div>
				<div v-for="(item,index) in gowuche.list">
					<div class="titou">
						<div class="name">{{item.title}}</div>
						<div style="color: #2795EF; text-decoration:underline;" @click="gotu(item.id)">详情</div>
					</div>
					<div class="jiage" style="color: #F1452F;">￥{{item.price}}</div>
					<div class="jbq">
						<van-stepper min="0" v-model="item.num" @change="onChange(item.id,item.num)" />
					</div>
				</div>
			</div>
		</van-popup>
		<div style="width: 100%; height: 3rem; position: fixed; bottom: 0; z-index: 9999; box-shadow: #ccc 0px 0px 10px; ">
			<van-submit-bar :price="(gowuche.total || 0)" suffix-label="/月起" button-text="下一步" @submit="go">
				<van-icon style="margin-right: 1.25rem;" :badge="gowuche.allnum || 0" size="25px" color="#F1452F" name="cart"
				 @click="show=!show" />
				<van-icon size="25px" color="#F1452F" name="service" @click="open53()" />
			</van-submit-bar>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'packages',
		props: {},
		data() {
			return {
				active: 0, // 当前激活的导航索引 锚点定位
				seelists: "", // 商品数据
				show: false, // 已经选择的商品模板的显示隐藏
				arr: [], // 选择的数组
				gowuche: '' // 已经选择的数据
			}
		},
		created() {
			this.getseelists() // 获取浏览记录
		},
		mounted() {
			// 监听滚动事件
			window.addEventListener('scroll', this.onScroll, false)
		},
		destroy() {
			// 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
			window.removeEventListener('scroll', this.onScroll)
		},
		methods: {
			// 获取商品信息
			getseelists() {
				this.$axios.post(baseUrl + '/mobile/whole/categorylist').then((res) => {
					this.seelists = res.data.data
				}).catch((err) => {
					console.log(err);
				});
			},
			// 选择数量 获取已经选择的数据
			unique(arr) {
				const res = new Map();
				return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1));
			},
			// 选择数量 获取已经选择的数据
			onChange(id, num) {
				if (localStorage.getItem('Authorization') == null) {
					this.$router.push({
						path: '/login',
					})
				}
				for (var i = 0; i < this.arr.length; i++) {
					if (this.arr[i].id == id) {
						this.arr[i].num = num;
						if (this.arr[i].num == 0) {
							this.arr.splice(i, 1)

						}
					} else {
						this.arr.push({
							id: id,
							num: num
						});
					}
				}
				this.arr.push({
					id: id,
					num: num
				});
				this.arr = this.unique(this.arr);
				this.$axios.post(baseUrl + '/mobile/whole/toprice', this.arr).then((res) => {
					if (res.data.code == 4) {
						this.gowuche = ''
						window.localStorage.removeItem('whole')
						this.show = false
					} else {
						localStorage.setItem('whole', JSON.stringify(res.data.data));
						this.gowuche = res.data.data
						this.gowuche.total = res.data.data.total * 100
					}
				}).catch((err) => {
					console.log(err);
				});
			},
			// 滚动监听器
			onScroll() {
				// 获取所有锚点元素
				const navContents = document.querySelectorAll('.div')
				// 所有锚点元素的 offsetTop
				const offsetTopArr = []
				navContents.forEach(item => {
					offsetTopArr.push(item.offsetTop - 65)
				})
				// 获取当前文档流的 scrollTop
				const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
				// 定义当前点亮的导航下标
				let navIndex = 0
				for (let n = 0; n < offsetTopArr.length; n++) {
					// 如果 scrollTop 大于等于第n个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
					// 那么此时导航索引就应该是n了
					if (scrollTop >= offsetTopArr[n]) {
						navIndex = n
					}
				}
				this.active = navIndex
			},
			go() {
				if (this.gowuche == '') {
					this.$toast('您还没有选择商品');
					return false;
				};
				this.$router.push({
					path: '/wholesubmit',
				})
			},
			gotu(e) {
				this.$router.push({
					path: '/packlist',
					query: {
						id: e,
					}
				})
			},
			// 跳转到指定索引的元素
			scrollTo(index) {
				// 获取目标的 offsetTop
				// css选择器是从 1 开始计数，我们是从 0 开始，所以要 +1
				const targetOffsetTop = document.querySelector(` .div:nth-child(${index + 1})`).offsetTop - 65
				// 获取当前 offsetTop
				let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
				// 定义一次跳 50 个像素，数字越大跳得越快，但是会有掉帧得感觉，步子迈大了会扯到蛋
				const STEP = 50
				// 判断是往下滑还是往上滑
				if (scrollTop > targetOffsetTop) {
					// 往上滑
					smoothUp()
				} else {
					// 往下滑
					smoothDown()
				}
				// 定义往下滑函数
				function smoothDown() {
					// 如果当前 scrollTop 小于 targetOffsetTop 说明视口还没滑到指定位置
					if (scrollTop < targetOffsetTop) {
						// 如果和目标相差距离大于等于 STEP 就跳 STEP
						// 否则直接跳到目标点，目标是为了防止跳过了。
						if (targetOffsetTop - scrollTop >= STEP) {
							scrollTop += STEP
						} else {
							scrollTop = targetOffsetTop
						}
						document.body.scrollTop = scrollTop
						document.documentElement.scrollTop = scrollTop
						// 关于 requestAnimationFrame 可以自己查一下，在这种场景下，相比 setInterval 性价比更高
						requestAnimationFrame(smoothDown)
					}
				}
				// 定义往上滑函数
				function smoothUp() {
					if (scrollTop > targetOffsetTop) {
						if (scrollTop - targetOffsetTop >= STEP) {
							scrollTop -= STEP
						} else {
							scrollTop = targetOffsetTop
						}
						document.body.scrollTop = scrollTop
						document.documentElement.scrollTop = scrollTop
						requestAnimationFrame(smoothUp)
					}
				}
			}
		}
	}
</script>

<style scoped>
	/* 内容区的样式 */
	.packages .content {
		background-color: #f7f7f7;
		width: 83%;
		margin-left: 17%;
	}

	.packages .content .div {
		width: 96%;
		font-size: 0.9rem;
		margin: auto;
	}

	/* 导航栏的样式 */
	.packages .navs {
		background-color: #efefef;
		width: 17%;
		font-size: 12px;
		height: 83vh;
		position: fixed;
		left: 0;
	}

	.packages .navs li>div {
		padding: 0.5rem 0;
		border-top: 1px solid #e4e4e4;
	}

	/* 当导航被点亮后改变颜色 */
	.packages .navs .active {
		color: #fff;
		background-color: #F1452F;
	}

	.packages .title {
		text-align: left;
		margin: 0 0.4rem;
	}

	.packages .content .block {
		padding: 0.3rem;
		background-color: #fff;
		display: flex;
		justify-content: space-between;
		margin-bottom: 12px;
		border-radius: 5px;
	}

	.packages .content .block:last-child {
		margin-bottom: 0px;
	}

	.packages .block img {
		width: 40%;
		text-align: right;
		height: 105px;
	}

	.packages .right {
		width: 55%;
	}

	.packages .text {
		width: 100%;
		text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		-webkit-box-orient: vertical;
		font-size: 13px;
		text-align: left;
		height: 2.25rem;

	}

	.packages .price {
		text-align: right;
		font-size: 17px;
		color: red;
		margin-top: 8px;
	}

	.packages .van-submit-bar__bar {
		padding: 0 6px;
	}

	.packages .gouwuche {
		padding: 1rem 1.25rem;
		text-align: left;
		font-size: 0.8125rem;
		line-height: 1.875rem;
	}

	.packages .gouwuche>div {
		display: flex;
		justify-content: space-between;
		margin-bottom: 0.625rem;
	}

	.packages .gouwuche .titou {
		display: flex;
		justify-content: space-between;
		width: 50%;
	}

	.packages .zhuangshi {
		display: inline-flex;
		padding: 0.625rem 0;
	}

	.packages .zhuangshi img {
		width: 1.5rem;
		height: 0.9375rem;
		margin-top: 0.125rem;
	}

	.packages .gouwuche .titou .name {
		width: 80%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.packages .shuxing {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		font-size: 0.75rem;
		text-align: left;
		width: 3.75rem;
		height: 2.125rem;
		line-height: 2.125rem;
	}

	.packages .xinjiu {
		position: absolute;
		top: 5px;
		left: 5px;
		background-color: red;
		font-size: 12px;
		color: rgb(238, 238, 238);
		padding: 1px 10px 1px 10px;
		border-bottom-right-radius: 999px;
		border-top-right-radius: 999px;
	}
</style>



// WEBPACK FOOTER //
// src/components/packages/packages.vue